import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Users, Receipt, LogOut, Building, FileText, TrendingUp, Package, Briefcase, Wrench, User, HeartHandshake, BarChart3 } from 'lucide-react';
import SupabaseStatus from './SupabaseStatus';

const Sidebar = ({ user, onLogout }) => {
  const userEmail = user?.email || 'Authenticated User';
  const displayName = user?.user_metadata?.name || (user?.email ? user.email.split('@')[0] : 'Admin');

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-brand">
          <Building size={28} />
          <span>PG Manage</span>
        </div>
      </div>
      <nav className="sidebar-nav">
        <NavLink 
          to="/" 
          end
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
          <LayoutDashboard size={20} />
          <span>Dashboard</span>
        </NavLink>
        <NavLink 
          to="/tenants" 
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
          <Users size={20} />
          <span>Tenants</span>
        </NavLink>
        <NavLink 
          to="/expenses" 
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
          <Receipt size={20} />
          <span>Expenses</span>
        </NavLink>
        <NavLink 
          to="/category-breakdown" 
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
          <BarChart3 size={20} />
          <span>Category Breakdown</span>
        </NavLink>
        <NavLink 
          to="/personal-expenses" 
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
          <HeartHandshake size={20} />
          <span>Personal Expenses</span>
        </NavLink>
        <NavLink 
          to="/initial-setup-expenses" 
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
          <Wrench size={20} />
          <span>Initial Setup</span>
        </NavLink>
        <NavLink 
          to="/invoices" 
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
          <FileText size={20} />
          <span>Invoices</span>
        </NavLink>
        <NavLink 
          to="/inward-money" 
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
          <TrendingUp size={20} />
          <span>Inward Money</span>
        </NavLink>
        <NavLink 
          to="/inventory" 
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
          <Package size={20} />
          <span>Inventory</span>
        </NavLink>
        <NavLink 
          to="/investment-analytics" 
          className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
        >
          <Briefcase size={20} />
          <span>Investment Analytics</span>
        </NavLink>
        
        <div style={{ flex: 1 }}></div>

        <SupabaseStatus />

        {/* User Profile Summary */}
        <div style={{
          padding: '0.65rem 0.85rem',
          margin: '0.5rem 0 0.25rem',
          background: 'var(--bg-secondary, rgba(255,255,255,0.03))',
          borderRadius: '8px',
          border: '1px solid rgba(255,255,255,0.08)',
          display: 'flex',
          alignItems: 'center',
          gap: '0.6rem'
        }}>
          <div style={{
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            background: 'var(--primary-color, #4f46e5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            flexShrink: 0
          }}>
            <User size={16} />
          </div>
          <div style={{ overflow: 'hidden', flex: 1 }}>
            <div style={{ fontSize: '0.82rem', fontWeight: 600, color: 'var(--text-main, #f8fafc)', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
              {displayName}
            </div>
            <div style={{ fontSize: '0.72rem', color: 'var(--text-secondary, #94a3b8)', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
              {userEmail}
            </div>
          </div>
        </div>
        
        <button 
          onClick={onLogout} 
          className="nav-link" 
          style={{ background: 'transparent', width: '100%', textAlign: 'left' }}
        >
          <LogOut size={20} color="var(--danger-color)" />
          <span style={{ color: 'var(--danger-color)' }}>Logout</span>
        </button>
      </nav>
    </div>
  );
};

export default Sidebar;
